<template>
  <div>
    <CRow>
      <!-- Panel izquierdo: formulario para generar reporte -->
      <CCol xs="12" sm="12" md="12" lg="4" xl="3">
        <CCard>
          <CCardHeader>
            <b><i class="fas fa-file-invoice-dollar"></i>&nbsp;Generar Reporte</b>
          </CCardHeader>
          <CCardBody>
            <CRow>
              <CCol sm="12" md="12" lg="12">
                <label class="col-form-label col-form-label-sm">Trabajadora</label>
                <select class="form-control form-control-sm" v-model="form.barber_id">
                  <option value="" disabled>Seleccionar...</option>
                  <option v-for="b in barbers" :key="b.id" :value="b.id">
                    {{ b.name }} {{ b.last_name }}
                  </option>
                </select>
              </CCol>

              <CCol sm="12" md="6" lg="6">
                <CInput label="Período inicio" type="date" size="sm" v-model="form.periodo_inicio" />
              </CCol>

              <CCol sm="12" md="6" lg="6">
                <CInput label="Período fin" type="date" size="sm" v-model="form.periodo_fin" />
              </CCol>

              <CCol sm="12" md="6" lg="6">
                <label class="col-form-label col-form-label-sm">Tipo de período</label>
                <select class="form-control form-control-sm" v-model="form.tipo_periodo">
                  <option value="quincenal">Quincenal</option>
                  <option value="mensual">Mensual</option>
                </select>
              </CCol>

              <CCol sm="12" md="6" lg="6" class="mt-4">
                <CButton color="primary" size="sm" class="w-100" :disabled="generating" @click="mtd_generate">
                  <span v-if="generating">
                    <i class="fas fa-spinner fa-spin"></i> Generando...
                  </span>
                  <span v-else>
                    <i class="fas fa-plus"></i> Generar reporte
                  </span>
                </CButton>
              </CCol>
            </CRow>

            <hr />

            <!-- Filtros de búsqueda -->
            <CRow>
              <CCol sm="12" md="6" lg="6">
                <label class="col-form-label col-form-label-sm">Filtrar por trabajadora</label>
                <select class="form-control form-control-sm" v-model="filter.barber_id" @change="mtd_data">
                  <option value="">Todas</option>
                  <option v-for="b in barbers" :key="b.id" :value="b.id">
                    {{ b.name }} {{ b.last_name }}
                  </option>
                </select>
              </CCol>

              <CCol sm="12" md="6" lg="6">
                <label class="col-form-label col-form-label-sm">Estado</label>
                <select class="form-control form-control-sm" v-model="filter.state" @change="mtd_data">
                  <option value="">Todos</option>
                  <option value="0">Pendiente</option>
                  <option value="1">Pagado</option>
                </select>
              </CCol>
            </CRow>
          </CCardBody>
        </CCard>
      </CCol>

      <!-- Panel derecho: tabla de reportes -->
      <CCol xs="12" sm="12" md="12" lg="8" xl="9">
        <CCard>
          <CCardHeader class="d-flex justify-content-between align-items-center">
            <b><i class="fas fa-coins"></i>&nbsp;Reportes de Pago</b>
            <CButton color="secondary" size="sm" @click="mtdBack">
              <i class="fas fa-arrow-left"></i> Volver
            </CButton>
          </CCardHeader>
          <CCardBody>
            <CDataTable :items="data" :fields="fields" hover :striped="true" :border="true" small fixed size="md">
              <template #state_label="{ item }">
                <td>
                  <CBadge :color="item.state === 1 ? 'success' : 'warning'">
                    {{ item.state_label }}
                  </CBadge>
                </td>
              </template>

              <template #total_pagar="{ item }">
                <td class="text-right font-weight-bold">
                  S/ {{ item.total_pagar }}
                </td>
              </template>

              <template #acciones="{ item }">
                <td class="text-center">
                  <div class="d-flex justify-content-center gap-2">
                    <CButton color="info" size="sm" @click="mtd_show(item)" v-c-tooltip="'Ver detalle'">
                      <i class="fas fa-eye"></i>
                    </CButton>
                    <CButton v-if="item.state === 0" color="danger" size="sm" @click="mtd_delete(item)"
                      v-c-tooltip="'Eliminar reporte'">
                      <i class="fas fa-trash"></i>
                    </CButton>
                  </div>
                </td>
              </template>
            </CDataTable>
          </CCardBody>
        </CCard>
      </CCol>
    </CRow>
  </div>
</template>

<script>
import { mapActions } from "vuex";

const fields = [
  { key: "index", label: "#", _style: "width:3%" },
  { key: "barber_name", label: "Trabajadora", _style: "width:20%" },
  { key: "periodo_inicio", label: "Desde", _style: "width:12%" },
  { key: "periodo_fin", label: "Hasta", _style: "width:12%" },
  { key: "tipo_periodo", label: "Tipo", _style: "width:10%" },
  { key: "total_pagar", label: "Total", _style: "width:12%" },
  { key: "state_label", label: "Estado", _style: "width:10%" },
  { key: "fecha_pago", label: "Fecha pago", _style: "width:12%" },
  { key: "acciones", label: "", _style: "width:5%" },
];

export default {
  name: "reporte-pagos",

  data() {
    return {
      prefix: "paymentReport",
      prefix_barbers: "assists",
      fields,
      data: [],
      barbers: [],
      generating: false,

      form: {
        barber_id: "",
        periodo_inicio: "",
        periodo_fin: "",
        tipo_periodo: "quincenal",
      },

      filter: {
        barber_id: "",
        state: "",
      },
    };
  },

  created() {
    this.mtd_barbers();
    this.mtd_data();
  },

  methods: {
    ...mapActions(["get", "post"]),

    mtdBack() {
      this.$emit("mtdBack");
    },

    // ─── Carga trabajadoras para los selects ──────────────────────
    mtd_barbers() {
      this.get({
        url: `${this.$store.getters.get__url}/${this.prefix_barbers}/byEncargados/${this.$store.getters.get_company.id}/${this.$store.getters.get_campu.id}`,
        token: this.$store.getters.get__token,
      }).then((response) => {
        if (response.statusCode == 200) {
          this.barbers = response.data.data;
        }
      });
    },

    // ─── Carga listado de reportes ────────────────────────────────
    mtd_data() {
      const params = new URLSearchParams();
      if (this.filter.barber_id) params.append("barber_id", this.filter.barber_id);
      if (this.filter.state !== "") params.append("state", this.filter.state);

      const query = params.toString() ? `?${params.toString()}` : "";

      this.get({
        url: `${this.$store.getters.get__url}/${this.prefix}/index/${this.$store.getters.get_company.id}/${this.$store.getters.get_campu.id}${query}`,
        token: this.$store.getters.get__token,
      }).then((response) => {
        if (response.statusCode == 200) {
          this.data = response.data.map((item, index) => ({
            ...item,
            index: index + 1,
            fecha_pago: item.fecha_pago ?? "—",
          }));
        }
      }).catch(() => {
        Swal.fire({ title: "Error al cargar reportes", icon: "error" });
      });
    },

    // ─── Genera el reporte ────────────────────────────────────────
    mtd_generate() {
      if (!this.form.barber_id) {
        Swal.fire({ title: "Selecciona una trabajadora", icon: "warning" });
        return;
      }
      if (!this.form.periodo_inicio || !this.form.periodo_fin) {
        Swal.fire({ title: "Ingresa el período completo", icon: "warning" });
        return;
      }
      if (this.form.periodo_fin <= this.form.periodo_inicio) {
        Swal.fire({ title: "La fecha fin debe ser posterior a la fecha inicio", icon: "warning" });
        return;
      }

      this.generating = true;

      this.post({
        url: `${this.$store.getters.get__url}/${this.prefix}/generate`,
        token: this.$store.getters.get__token,
        params: {
          barber_id: this.form.barber_id,
          periodo_inicio: this.form.periodo_inicio,
          periodo_fin: this.form.periodo_fin,
          tipo_periodo: this.form.tipo_periodo,
          user_id: this.$store.getters.get__user_id,
          company_id: this.$store.getters.get_company.id,
          campu_id: this.$store.getters.get_campu.id,
        },
      }).then((response) => {
        this.generating = false;
        if (response.statusCode == 200) {
          Swal.fire({ title: "Reporte generado correctamente", icon: "success", timer: 1500 });
          this.mtd_data();
          // Navegar directamente al detalle del reporte generado
          this.$emit("mtd_show", response.data);
        } else {
          Swal.fire({ title: response.message ?? "Error al generar el reporte", icon: "error" });
        }
      }).catch(() => {
        this.generating = false;
        Swal.fire({ title: "Error al generar el reporte", icon: "error" });
      });
    },
    mtd_show(item) {
      this.$emit("mtd_show", item);
    },
    mtd_delete(item) {
      Swal.fire({
        title: "¿Eliminar reporte?",
        text: `Reporte de ${item.barber_name} (${item.periodo_inicio} - ${item.periodo_fin})`,
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#d33",
        cancelButtonColor: "#6c757d",
        confirmButtonText: "Sí, eliminar",
        cancelButtonText: "Cancelar",
      }).then((result) => {
        if (result.isConfirmed) {
          this.post({
            url: `${this.$store.getters.get__url}/${this.prefix}/destroy/${item.Id}`,
            token: this.$store.getters.get__token,
          }).then((response) => {
            if (response.statusCode == 200) {
              Swal.fire({ title: "Reporte eliminado", icon: "success", timer: 1500 });
              this.mtd_data();
            } else {
              Swal.fire({ title: response.message ?? "Error al eliminar", icon: "error" });
            }
          }).catch(() => {
            Swal.fire({ title: "Error al eliminar el reporte", icon: "error" });
          });
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped></style>